import appConfig from '@configs/appConfig';
import getData from '@services/api/common/getData';
import postData from '@services/api/common/postData';
import { mfaInfo, verifyMfaInfo } from '@constants/appRoutes';

export const getMfaInfo = () => getData(appConfig.baseUrl.concat(mfaInfo));

export const postMfaInfo = data =>
  postData(`${appConfig.baseUrl}${verifyMfaInfo}`, data);
